import axios from "axios";
import { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { notificationActions } from "../../data/notification";
import { useDispatch, useSelector } from "react-redux";
import { XCircle } from "react-bootstrap-icons";
import useT from "../../i18n/useT";

const UploadImages = ({show, id, setShow}) => {
    const [images, setImages] = useState(null);
    const [loader, setLoader] = useState(false);
    const dispatch = useDispatch();
    const lang = useSelector((state) => state.user.language);
    const [handler, setHandler] = useState("");
    const t = useT();

    useEffect(() => {
        setImages(null);
        setHandler("")
    }, [show])

    const handlers = {
        uploadAuctionImage(){
            setLoader(true);
            const imagesForm = new FormData();
            for(let i = 0; i < images.length; i++){
                imagesForm.append("auction-images", images[i])
            }
            axios.post(`/api/cars/${id}/auction-images`, imagesForm)
                .then((res) => {
                    setLoader(false);
                    dispatch(notificationActions.changeNotification({show: true, text: res.data.message[lang], type: "success-notification"}))
                    setTimeout(() => {
                        dispatch(notificationActions.changeNotification({show: false, text: "", type: ""}))
                    }, 4000);
                    setShow(false);
                })
                .catch((err) => {
                    setLoader(false);
                    dispatch(notificationActions.changeNotification({show: true, text: err.response.data.message[lang], type: "error-notification"}))
                    setTimeout(() => {
                        dispatch(notificationActions.changeNotification({show: false, text: "", type: ""}))
                    }, 4000);
                })
        },
        uploadPortImage(){
            setLoader(true);
            const imagesForm = new FormData();
            for(let i = 0; i < images.length; i++){
                imagesForm.append("port-images", images[i])
            }
            axios.post(`/api/cars/${id}/port-images`, imagesForm)
                .then((res) => {
                    setLoader(false);
                    dispatch(notificationActions.changeNotification({show: true, text: res.data.message[lang], type: "success-notification"}))
                    setTimeout(() => {
                        dispatch(notificationActions.changeNotification({show: false, text: "", type: ""}))
                    }, 4000);
                    setShow(false);
                })
                .catch((err) => {
                    setLoader(false);
                    dispatch(notificationActions.changeNotification({show: true, text: err.response.data.message[lang], type: "error-notification"}))
                    setTimeout(() => {
                        dispatch(notificationActions.changeNotification({show: false, text: "", type: ""}))
                    }, 4000);
                })
        },
        uploadPotiImage(){
            setLoader(true);
            const imagesForm = new FormData();
            for(let i = 0; i < images.length; i++){
                imagesForm.append("poti-images", images[i])
            }
            axios.post(`/api/cars/${id}/poti-images`, imagesForm)
                .then((res) => {
                    setLoader(false);
                    dispatch(notificationActions.changeNotification({show: true, text: res.data.message[lang], type: "success-notification"}))
                    setTimeout(() => {
                        dispatch(notificationActions.changeNotification({show: false, text: "", type: ""}))
                    }, 4000);
                    setShow(false);
                })
                .catch((err) => {
                    setLoader(false);
                    dispatch(notificationActions.changeNotification({show: true, text: err.response.data.message[lang], type: "error-notification"}))
                    setTimeout(() => {
                        dispatch(notificationActions.changeNotification({show: false, text: "", type: ""}))
                    }, 4000);
                })
        },
        uploadTransportationImage(){
            setLoader(true);
            const imagesForm = new FormData();
            for(let i = 0; i < images.length; i++){
                imagesForm.append("transportation-images", images[i])
            }
            axios.post(`/api/cars/${id}/transportation-images`, imagesForm)
                .then((res) => {
                    setLoader(false);
                    dispatch(notificationActions.changeNotification({show: true, text: res.data.message[lang], type: "success-notification"}))
                    setTimeout(() => {
                        dispatch(notificationActions.changeNotification({show: false, text: "", type: ""}))
                    }, 4000);
                    setShow(false);
                })
                .catch((err) => {
                    setLoader(false);
                    dispatch(notificationActions.changeNotification({show: true, text: err.response.data.message[lang], type: "error-notification"}))
                    setTimeout(() => {
                        dispatch(notificationActions.changeNotification({show: false, text: "", type: ""}))
                    }, 4000);
                })
        }
    }

    return(
        <Modal show={show} onHide={() => setShow(false)} size="xl" centered>
            <Modal.Header closeButton><h3>{t("vehicles.uploadImages")}</h3></Modal.Header>
            <Modal.Body>
                <select style={{marginBottom: "30px"}} className="form-control" onChange={(e) => setHandler(e.target.value)}>
                    <option value={""}>{t("vehicles.selectImageType")}</option>
                    <option value={"uploadAuctionImage"}>{t("vehicles.auction")}</option>
                    <option value={"uploadTransportationImage"}>{t("vehicles.transportation")}</option>
                    <option value={"uploadPortImage"}>{t("vehicles.port")}</option>
                    <option value={"uploadPotiImage"}>{t("vehicles.poti")}</option>
                </select>
                <form onSubmit={(e) => {
                    e.preventDefault();
                    if(handler != ""){
                        handlers[handler]()
                    }else{
                        dispatch(notificationActions.changeNotification({show: true, text: t("vehicles.selectImageTypeWarning"), type: "warning-notification"}))
                        setTimeout(() => {
                            dispatch(notificationActions.changeNotification({show: false, text: "", type: ""}))
                        }, 4000);
                    }
                }}>
                    <label htmlFor='attach-auction-images' className='attach-auction-images'><img src='/static/icons/image.png' style={{width: "50px"}}/><span>{t("vehicles.attachImage")}</span></label>
                    <input id='attach-auction-images' type='file'  hidden accept="image/*" multiple onChange={(e) => {
                        setImages((prev) => (prev == null ? Array.from(e.target.files) : [...prev, Array.from(e.target.files)]));
                    }}/>
                    <div className='auction-images-list'>
                        {
                            (images != null && images.length > 0) && images.map((image, index) => {
                                return <div className='auction-image'>
                                    <XCircle onClick={() => {
                                        const imgs = images.filter((img, i) => i != index);
                                        setImages(imgs);
                                    }} width={"20px"} height={"20px"} style={{color: "white", position: "absolute", marginTop: "15px", marginLeft: "150px", cursor: "pointer"}}/>
                                    <img src={URL.createObjectURL(image)} style={{width: "180px"}}/>
                                </div>
                            })
                        }
                    </div>
                    <Modal.Footer style={{marginTop: "1.5rem"}}>
                        <Button type='submit' disabled={loader} variant={loader ? 'secondary' : 'primary'}>{loader ? <div className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div> : t("vehicles.upload")}</Button>
                        <Button type='button' disabled={loader} onClick={() => setShow(false)} variant='danger'>{t("common.close")}</Button>
                    </Modal.Footer>
                </form>
            </Modal.Body>
        </Modal>
    )
}

export default UploadImages